export const FEATURE_STORE_LIST = {
  garden: {
    title: 'Garden Center',
    link: '/garden-center',
  },
  services: {
    title: 'Home Services',
    link: '/services',
  },
  rentals: {
    title: 'Rentals',
    link: '/rentals',
  }
};
